import styled from 'styled-components';
import device from '../../../../GlobalDigitalStyle/BreakPoint.style';

export const StatsContainer = styled.div`
	padding: 0 7em;
	height: 20em;
	@media ${device.screen1680} {
		padding: 0 5em;
		height: 18em;
	}
	@media ${device.screen1366} {
		padding: 0 5em;
		height: 16em;
	}
	@media ${device.screen1050} {
		padding: 0 3em;
		height: 14em;
	}
	.stat__container {
		display: flex;
		flex-direction: column;
		gap: 0.5em;
		justify-content: center;
		.stat__number {
			font-size: xx-large;
			@media ${device.screen1440} {
				font-size: x-large;
			}
		}
	}
	.text__default {
		font-weight: 600;
		font-size: 15px;
		@media ${device.screen1680} {
			font-size: 14px;
		}
		@media ${device.screen1280} {
			font-size: 12.8px;
		}
		@media ${device.screen1050} {
			font-size: 11px;
		}
	}
`;
